// 配置编译环境和线上环境之间的切换

const env = process.env
let baseUrl = process.env.VUE_APP_BASIC_API
let mcTokenUrl = process.env.VUE_APP_MC_TOKEN_API
let loginGrantType = process.env.VUE_APP_LOGIN_GRANT_TYPE
// 图表库为avue和pig2套地址
let iconfontVersion = ['567566_qo5lxgtishg', '667895_vf6hgm08ubf']
let iconfontUrl = `//at.alicdn.com/t/font_$key.css`
let codeUrl = `${baseUrl}/code`

export {
  baseUrl,
  mcTokenUrl,
  loginGrantType,
  iconfontUrl,
  iconfontVersion,
  codeUrl,
  env
}
